module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d9ba5ee866df39f60291d55f77c4e331.png";